import { IAbcComponent } from '../abcComponent.model';

export interface IGrid extends IAbcComponent {
  columnsHeader: ColumnHeader[];
  gridData: any;
  contextMenuOptions?: any;
  setGridStyle(style?: GridStyle);
}

export interface GridStyle {
  width?: string;
  height?: string;
  showfilterrow?: boolean;
  selectedrow?: boolean;
  rowFilter?: boolean;
  showdefaultloadelement?: boolean;
  autoshowloadelement?: boolean;
  showBorders?: boolean;
  sortable?: boolean;
  showsortmenuitems?: boolean;
  columnsmenu?: boolean;
  columnsresize?: boolean;
  enabletooltips?: boolean;
  showemptyrow?: boolean;
  enableellipsis?: boolean;
  columnsreorder?: boolean;
  pageable?: boolean;
  autoshowfiltericon?: boolean;
  rendertoolbar?: boolean;
  showtoolbar?: boolean;
  editable?: boolean;
  editmode?: string;
  virtualmode?: boolean;
  autorowheight?: boolean;
  autoshowcolumnsmenubutton?: boolean;
  enableStateStorage?: boolean;
  columnHidingEnabled?: boolean;
  allowColumnReordering?: boolean;
  columnFilter?: boolean;
  filterable?: boolean;
  allowAdding?: boolean;
  allowColumnResizing?: boolean;
  rowAlternationEnabled?: boolean;
  showRowLines?: boolean;
  filterSyncEnabled?: boolean;
  showAddFloatingActionButton?: boolean;
  showDetails?: boolean;
  showColumnLines?: boolean;
  allowUpdating?: boolean;
  exportButton?: boolean;
  keyExpr?: string;
  showColumnHeaders?: boolean;
  hoverStateEnabled?: boolean;
  columnAutoWidth?: boolean;
  disabled?: boolean;
  visible?: boolean;
  enablePaging?: boolean;
  autoExpandAll?: boolean;
  allowedPageSizes?: string;
  searchPanel?: boolean;
  allowColumnChooserSearch?: boolean;
  placeholder?: string;
  text?: string;
  widthSearch?: string;
  highlightSearchText?: boolean;
  allowSelectAll?: boolean;
  selectionMode?: Mode;
  stateStorageKey?: string;
  showCheckBoxesMode?: ShowMode;
  filterPanel?: boolean;
  filterKey?: Array<string>;
  scrolleMode?: ScrollMode;
  rowRenderingMode?: RowMode;
  groupable?: boolean;
  useNative?: boolean;
  enableExport?: boolean;
  allowExportSelectedData?: boolean;
  allowDeleting?: boolean;
  rtlEnabled?: boolean;
  toolbarItems?: toolbarItems[];
  useIcons?: boolean;
  popUpTitle?: string;
  confirmDelete?: boolean;
  allowReordering?: boolean;
  showDragIcons?: boolean;
  showTitle?: boolean;
  popUpWidth?: string | number;
  popUpHeight?: string | number;
  editingMode?: EditingMode;
  sortingMode?: SortingMode;
  showClearBtn?: boolean;
  enableColumnFixing?: boolean;
  columnChooserSortOrder?: 'asc' | 'desc';
  showDropDownColumnHeaders?: boolean;
  allowSaveEditDataOnDDBoxClosed?: boolean;
  allowDDBoxAutoOpen?: boolean;
  dropDownBoxHeight?: string | number;
  selectedRowKey?: string;
  rowsheight?: number;
}

export enum Mode {
  Multiple = 'multiple',
  None = 'none',
  single = 'single',
}

export enum ScrollMode {
  Virtual = 'virtual',
  Infinite = 'infinite',
  Standard = 'standard',
}

export enum RowMode {
  Virtual = 'virtual',
  Standard = 'standard',
}

export enum ShowMode {
  Always = 'always',
  none = 'none',
  onClick = 'onClick',
  onLongTap = 'onLongTap',
}

export enum SortOrder {
  None = 'undefined',
  Ascending = 'asc',
  Descending = 'desc',
}

export enum DataType {
  Double = 'Double',
  String = 'String',
  Integer32 = 'Integer32',
  Boolean = 'Boolean',
  Date = 'Date',
  Button = 'button',
  DropDownList = 'dropdownlist',
  DateTimeInput = 'datetimeinput',
  ComboBox = 'ComboBox',
  Time = 'Time',
}

export class toolbarItems {
  widget: widget;
  location?: location;
  options: any;
}

export class ColumnHeader {
  name: string;
  dataField: string;
  internalName?: string;
  isRefColumn?: boolean;
  dataSource?: string;
  type?: DataType;
  groupIndex?: number;
  ColumnSizeWidth?: string;
  hidden?: boolean;
  displayExpr?: string;
  valueExpr?: string;
  showInColumnChooser?: boolean;
  cellEnabled?: boolean;
  editable?: boolean;
  editMask?: any;
  format?: any;
  filterValues?: Array<any>;
  dropDownSource?: any;
  dropDownColumnsHeader?: ColumnHeader[];
  alignment?: ColumnAlignment;
  actionMethod? = (row: any) => {};
  actionSvgIconName?: string;
  sortOrder?: SortOrder;
  sortIndex?: number;
  visibleIndex?: number;
  allowFixing?: boolean;
  fixed?: boolean;
  fixedPostion?: fixedPosition;
  sortNumber?: number;
  cellTemplate?: string;
  cellbeginedit?();
  cellvaluechanging?(row, datafield, columntype, oldvalue, newvalue);
  cellendedit?(row, datafield, columntype, oldvalue, newvalue);
  createeditor?(row?, cellvalue?, editor?, celltext?, cellwidth?, cellheight?);
  cellsrenderer?(editor);
  initeditor?(row?, cellvalue?, editor?);
  buttonclick?(row);
  createwidget?(row?, column?, value?, htmlElement?);
  initwidget?(row?, column?, value?, htmlElement?);
  customizeText?: any;
  defaultFilter?: { dataField: string; filterOperator: string; value?: any };

  constructor(data: any) {
    Object.assign(this, data);
  }
}

export enum StateStorageType {
  LocalStorage = 'localStorage',
  SessionStorage = 'sessionStorage',
  Custom = 'custom',
}

export enum StateStorage {
  table = '_table',
  objectInfo = '_oi_',
}

export enum fixedPosition {
  left = 'left',
  right = 'right',
}
export enum EditingMode {
  Batch = 'batch',
  Cell = 'cell',
  Row = 'row',
  Form = 'form',
  PopUp = 'popup',
}

export enum SortingMode {
  None = 'none',
  Single = 'single',
  Multiple = 'multiple',
}

export enum ColumnAlignment {
  Center = 'center',
  Left = 'left',
  Right = 'right',
}

export enum widget {
  dxAutocomplete = 'dxAutocomplete',
  dxButton = 'dxButton',
  dxCheckBox = 'dxCheckBox',
  dxDateBox = 'dxDateBox',
  dxMenu = 'dxMenu',
  dxSelectBox = 'dxSelectBox',
  dxTabs = 'dxTabs',
  dxTextBox = 'dxTextBox',
  dxButtonGroup = 'dxButtonGroup',
  dxDropDownButton = 'dxDropDownButton',
}

export enum location {
  after = 'after',
  before = 'before',
  center = 'center',
}

export const DISPLAYTEXT = '__DISPLAY_TEXT__';
